import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IGetQueryParams,
  IFetchPromoActionResponse,
  IVolumetricPromoDetailResponseNormalized,
  ICreatePromoPayload,
  ICreateBasketPromoPayload,
  IBasketPromoDetailResponseNormalized,
  IPromoBasketDetailResponse,
  IPromoDetailResponse,
  IDynamicPromoDetailResponse,
  IDynamicPromoDetailResponseNormalized,
} from "../../interfaces/Index";
import {
  createPromoCityLevelApiCall,
  fetchPromoCityLevelDetailsApiCall,
  fetchPromosCityLevelApiCall,
  updatePromoCityLevelStatusApiCall,
  createBasketPromoCityLevelApiCall,
  fetchPromoCityLevelByTypeApiCall,
  fetchWarehouseByCityIdApiCall,
  fetchUCByCityIdApiCall,
  uploadUserLevelPromoCsvApiCall,
  createUserLevelBulkPromoApiCall,
  updatePromoCityLevelApiCall,
  deactivateUserLevelBulkPromoApiCall,
} from "../sources/PromoCityLevelSource";
import { IUpdatePromoPayload } from "interfaces/userLevelPromo.interface";
import { PromoType } from "components/pages/PromosCityLevel/constants/AddBulkPromosCityLevelConstats";

export const createPromoCityLevelInit = () => ({
  type: actionTypes.CREATE_PROMO_CITY_LEVEL_INIT,
});

export const createPromoCityLevelSuccess = (payload: any) => ({
  type: actionTypes.CREATE_PROMO_CITY_LEVEL_SUCCESS,
  payload,
});

export const createPromoCityLevelFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_PROMO_CITY_LEVEL_FAIL,
  error,
});

export const createPromoBulkInit = () => ({
  type: actionTypes.CREATE_PROMO_BULK_INIT,
});
export const createPromoBulkSuccess = (payload: any) => ({
  type: actionTypes.CREATE_PROMO_BULK_SUCCESS,
  payload,
});
export const createPromoBulkFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_PROMO_BULK_FAIL,
  error,
});

export const deactivatePromoBulkInit = () => ({
  type: actionTypes.DEACTIVATE_PROMO_BULK_INIT,
});
export const deactivatePromoBulkSuccess = (payload: any) => ({
  type: actionTypes.DEACTIVATE_PROMO_BULK_SUCCESS,
  payload,
});
export const deactivatePromoBulkFail = (error: string | object | null) => ({
  type: actionTypes.DEACTIVATE_PROMO_BULK_FAIL,
  error,
});

export const createBasketPromoCityLevelSuccess = () => ({
  type: actionTypes.CREATE_PROMO_CITY_LEVEL_SUCCESS,
});

export const fetchPromoCityLevelInit = () => ({
  type: actionTypes.GET_PROMOS_CITY_LEVEL_INIT,
});

export const fetchPromoCityLevelSuccess = (
  payload: IFetchPromoActionResponse | null
) => ({
  type: actionTypes.GET_PROMOS_CITY_LEVEL_SUCCESS,
  payload,
});

export const fetchPromoCityLevelFail = (error: string | object | null) => ({
  type: actionTypes.GET_PROMOS_CITY_LEVEL_FAIL,
  error,
});

export const fetchPromoCityLevelDetailsInit = () => ({
  type: actionTypes.GET_PROMO_CITY_LEVEL_DETAILS_INIT,
});

export const fetchPromoCityLevelDetailsSuccess = (
  payload:
    | IVolumetricPromoDetailResponseNormalized
    | IBasketPromoDetailResponseNormalized
    | IDynamicPromoDetailResponseNormalized
) => ({
  type: actionTypes.GET_PROMO_CITY_LEVEL_DETAILS_SUCCESS,
  payload,
});

export const fetchPromoCityLevelDetailsFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_PROMO_CITY_LEVEL_DETAILS_FAIL,
  error,
});

export const clearPromoCityLevelDetails = () => ({
  type: actionTypes.CLEAR_PROMO_CITY_LEVEL_DETAILS,
});

export const promoCityLevelUpdateStatusInit = () => ({
  type: actionTypes.UPDATE_PROMO_CITY_LEVEL_STATUS_INIT,
});

export const promoCityLevelUpdateStatusSuccess = () => ({
  type: actionTypes.UPDATE_PROMO_CITY_LEVEL_STATUS_SUCCESS,
});

export const promoCityLevelUpdateStatusFail = (
  error: string | object | null
) => ({
  type: actionTypes.UPDATE_PROMO_CITY_LEVEL_STATUS_FAIL,
  error,
});

export const promoCityLevelUpdateInit = () => ({
  type: actionTypes.UPDATE_PROMO_CITY_LEVEL_INIT,
});

export const promoCityLevelUpdateSuccess = () => ({
  type: actionTypes.UPDATE_PROMO_CITY_LEVEL_SUCCESS,
});

export const promoCityLevelUpdateFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_PROMO_CITY_LEVEL_FAIL,
  error,
});

export const fetchPromoCityLevelByTypeInit = () => ({
  type: actionTypes.GET_PROMO_CITY_LEVEL_BY_TYPE_INIT,
});

export const fetchPromoCityLevelByTypeSuccess = (
  payload:
    | IPromoDetailResponse[]
    | IPromoBasketDetailResponse[]
    | IDynamicPromoDetailResponse[]
) => ({
  type: actionTypes.GET_PROMO_CITY_LEVEL_BY_TYPE_SUCCESS,
  payload,
});

export const fetchPromoCityLevelByTypeFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_PROMO_CITY_LEVEL_BY_TYPE_FAIL,
  error,
});

export const fetchWarehouseByCityIdInit = () => ({
  type: actionTypes.GET_WAREHOUSE_INIT,
});

export const fetchWarehouseByCityIdSuccess = (payload: any) => ({
  type: actionTypes.GET_WAREHOUSE_SUCCESS,
  payload,
});

export const fetchWarehouseByCityIdFail = (error: any) => ({
  type: actionTypes.GET_WAREHOUSE_FAIL,
  error,
});

export const fetchUCByCityIdInit = () => ({
  type: actionTypes.GET_UC_BY_CITY_ID_INIT,
});

export const fetchUCByCityIdSuccess = (payload: any) => ({
  type: actionTypes.GET_UC_BY_CITY_ID_SUCCESS,
  payload,
});

export const fetchUCByCityIdFail = (error: any) => ({
  type: actionTypes.GET_UC_BY_CITY_ID_FAIL,
  error,
});

export const uploadUserLevelPromoInit = () => ({
  type: actionTypes.UPLOAD_USER_LEVEL_PROMO_CSV_INIT,
});

export const uploadUserLevelPromoSuccess = (payload: any) => ({
  type: actionTypes.UPLOAD_USER_LEVEL_PROMO_CSV_SUCCESS,
  payload,
});

export const uploadUserLevelPromoFail = (error: any) => ({
  type: actionTypes.UPLOAD_USER_LEVEL_PROMO_CSV_FAIL,
  error,
});

// async actions
export const createPromoCityLevel =
  (cityId: string, payload: ICreatePromoPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(createPromoCityLevelInit());
    return createPromoCityLevelApiCall(cityId, payload)
      .then((promoId) => dispatch(createPromoCityLevelSuccess(promoId)))
      .catch((e: object | null | string) =>
        dispatch(createPromoCityLevelFail(e))
      );
  };

export const createUploadUserLevelPromoActions =
  (cityId: string, payload: ICreatePromoPayload, csvPayload: FormData) =>
  async (dispatch: Dispatch<IActionType>) => {
    const promoData: IPromoDetailResponse = await createPromoCityLevelApiCall(
      cityId,
      payload
    );
    const promoIdCreatePromoCall = promoData.promoId;
    return uploadUserLevelPromoActions(
      promoIdCreatePromoCall,
      csvPayload
    )(dispatch);
    // .then((response: any) =>
    //   dispatch(uploadUserLevelPromoSuccess(response))
    // )
    // .catch((error: any) => dispatch(uploadUserLevelPromoFail(error)));
  };

export const uploadUserLevelPromoActions =
  (promoId: string, payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(uploadUserLevelPromoInit());
    return uploadUserLevelPromoCsvApiCall(promoId, payload)
      .then((response: any) => dispatch(uploadUserLevelPromoSuccess(response)))
      .catch((error: any) => dispatch(uploadUserLevelPromoFail(error)));
  };

export const getWarehouseByCityIdActions =
  (cityId: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchWarehouseByCityIdInit());
    return fetchWarehouseByCityIdApiCall(cityId)
      .then((response: any) =>
        dispatch(fetchWarehouseByCityIdSuccess(response))
      )
      .catch((error: any) => dispatch(fetchWarehouseByCityIdFail(error)));
  };

export const createBasketPromoCityLevel =
  (cityId: string, payload: ICreateBasketPromoPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(createPromoCityLevelInit());
    return createBasketPromoCityLevelApiCall(cityId, payload)
      .then(() => dispatch(createBasketPromoCityLevelSuccess()))
      .catch((e: object | null | string) =>
        dispatch(createPromoCityLevelFail(e))
      );
  };

export const getPromosCityLevel =
  (cityId: string, queryParams?: IGetQueryParams) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchPromoCityLevelInit());
    return fetchPromosCityLevelApiCall(cityId, queryParams)
      .then((productCityLevels: any) =>
        dispatch(fetchPromoCityLevelSuccess(productCityLevels))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchPromoCityLevelFail(e))
      );
  };

export const getPromoCityLevelDetails =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchPromoCityLevelDetailsInit());
    return fetchPromoCityLevelDetailsApiCall(id)
      .then(
        (
          details:
            | IVolumetricPromoDetailResponseNormalized
            | IBasketPromoDetailResponseNormalized
            | IDynamicPromoDetailResponseNormalized
        ) => dispatch(fetchPromoCityLevelDetailsSuccess(details))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchPromoCityLevelDetailsFail(e))
      );
  };

export const clearPromoCityLevelDetailsAction =
  () => (dispatch: Dispatch<IActionType>) => {
    return dispatch(clearPromoCityLevelDetails());
  };

export const updatePromoCityLevelStatus =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(promoCityLevelUpdateStatusInit());
    return updatePromoCityLevelStatusApiCall(id)
      .then(() => dispatch(promoCityLevelUpdateStatusSuccess()))
      .catch((e: object | null | string) =>
        dispatch(promoCityLevelUpdateStatusFail(e))
      );
  };

export const getPromoCityLevelByType =
  (cityId: string, type: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchPromoCityLevelByTypeInit());
    return fetchPromoCityLevelByTypeApiCall(cityId, type)
      .then(
        (
          promos:
            | IPromoBasketDetailResponse[]
            | IPromoDetailResponse[]
            | IDynamicPromoDetailResponse[]
        ) => dispatch(fetchPromoCityLevelByTypeSuccess(promos))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchPromoCityLevelByTypeFail(e))
      );
  };

export const getUCByCityIdActions =
  (cityId?: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchUCByCityIdInit());
    return fetchUCByCityIdApiCall(cityId)
      .then((response: any) => dispatch(fetchUCByCityIdSuccess(response)))
      .catch((error: any) => dispatch(fetchUCByCityIdFail(error)));
  };

export const createPromoBulkActions =
  (payload: FormData, promoType: PromoType) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(createPromoBulkInit());
    return createUserLevelBulkPromoApiCall(payload, promoType)
      .then((response: any) => dispatch(createPromoBulkSuccess(response)))
      .catch((error: any) => dispatch(createPromoBulkFail(error)));
  };

export const deactivatePromoBulkActions =
  (payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(deactivatePromoBulkInit());
    return deactivateUserLevelBulkPromoApiCall(payload)
      .then((response: any) => dispatch(deactivatePromoBulkSuccess(response)))
      .catch((error: any) => dispatch(deactivatePromoBulkFail(error)));
  };

export const updatePromoCityLevelActions =
  (id: string, payload: IUpdatePromoPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(promoCityLevelUpdateInit());
    return updatePromoCityLevelApiCall(id, payload)
      .then(() => dispatch(promoCityLevelUpdateSuccess()))
      .catch((e: object | null | string) =>
        dispatch(promoCityLevelUpdateFail(e))
      );
  };
